
// one show index
$(document).on( "pagecreate", '#index', function( event, ui ) {
$(document).one("pagecontainerbeforeshow", function (event,ui) {
  if (ui.toPage[0].id == 'index') {
    var page = ui.toPage[0];
    window.scrollTo(0, 0);

    if(jQuery('#slider-home-basic').length ) {
    var _0x2f5d=["slick","#slider-home-basic"];jQuery(_0x2f5d[1]).not('.slick-initialized')[_0x2f5d[0]]({infinite:true,speed:300,slidesToShow:1,adaptiveHeight:true,autoplay:true,autoplaySpeed:8000})
      }else{  
    
     var slider = jQuery(page).find('.rev_slider');
     if(!slider.hasClass('revslider-initialised')) {
        createhomepageslider();
      }else{
      slider.revredraw();
      slider.revresume();
     }
     }
    
    productslider();
    shoutoutsslider();

  }
});
});




// one show index

$(document).one("pagecontainerbeforeshow", function (event,ui) {
    var page = ui.toPage[0];
   runig(page);
});






jQuery(document).on("pagecreate", "#pagehelp-contact", function(event) {
  autocompletesearch();  
  helpaccordion();
  
});


$(document).one("pagecontainerbeforeshow", function (event,ui) {
  if (ui.toPage[0].id == 'searchfaq') {
  autocompletesearch();  
  helpaccordion();
 }
});



jQuery(document).on("pagecreate", "#searchfaq", function(event) {
  autocompletesearch();  
  helpaccordion();
});



// Update the contents of the toolbars
$(document).on("pagecreate", ".ui-page", function(event) {
  setTimeout(function() {
    initmodals(event); 
  }, 1000);
});


function helpaccordion() {
    var acc = document.getElementsByClassName("accordion");
    var i;
    for (i = 0; i < acc.length; i++) {
        jQuery(acc[i]).off('click').on('click', function() {
            jQuery(this).parent().get(0).classList.toggle("active");
        });
    }
}




function autocompletesearch() {
    // Current Ajax request.
    var currentAjaxRequest = null;
    // Grabbing all search forms on the page, and adding a .search-results list to each.
    // Grabbing text input.
    var input = $('#helpsearch');
    // Listening to keyup and change on the text field within these search forms.
    input.attr('autocomplete', 'off').bind('keyup change', function() {
        // What's the search term?
        var term = $(this).val();
        // What's the search form?
        var form = $(this).closest('form');
        // What's the search URL?
        var searchURL = '/search?type=article&q=' + term;
        // What's the search results list?
        var resultsList = jQuery('#searchhelp-results');
        var resultsListWrap = jQuery('#searchhelp-results-wrap');
        // If that's a new term and it contains at least 3 characters.
        if (term.length > 3 && term != $(this).attr('data-old-term')) {
            // Saving old query.
            $(this).attr('data-old-term', term);
            // Killing any Ajax request that's currently being processed.
            if (currentAjaxRequest != null) currentAjaxRequest.abort();
            // Pulling results.
            currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {
                // Reset results.
                resultsList.empty();
                // If we have no results.
                if (data.results_count == 0) {
                    // resultsList.html('<li><span class="title">No results.</span></li>');
                    // resultsList.fadeIn(200);
                    resultsListWrap.removeClass('active');
                } else {
                    // If we have results.
                    var i = 0;
                    var results = '';
                    $.each(data.results, function(index, item) {
                        // get the parent blog id
                        blog_id = item.object.blog_id;
                        // get blog ids of help page blogs
                        var help1 = 'frequently-asked-question';
                        if (item.bloghandle == help1) {
                            i++;
                            data.results_count = i;
                            console.log(item);
                            results += '<li><a href="' + item.url + '?view=faq">' + item.title + '</a></li>';
                        }
                    });
                    resultsList.html(results);
                    resultsListWrap.addClass('active');
                }
            });
        } else if (term.length < 3) {
            resultsListWrap.removeClass('active');
        }
    });
}



// createhomepage slider
function setREVStartSize(e) {
    try {
        var i = jQuery(window).width(),
            t = 9999,
            r = 0,
            n = 0,
            l = 0,
            f = 0,
            s = 0,
            h = 0;
        if (e.responsiveLevels && (jQuery.each(e.responsiveLevels, function(e, f) {
                f > i && (t = r = f, l = e), i > f && f > r && (r = f, n = e)
            }), t > r && (l = n)), f = e.gridheight[l] || e.gridheight[0] || e.gridheight, s = e.gridwidth[l] || e.gridwidth[0] || e.gridwidth, h = i / s, h = h > 1 ? 1 : h, f = Math.round(h * f), "fullscreen" == e.sliderLayout) {
            var u = (e.c.width(), jQuery(window).height());
            if (void 0 != e.fullScreenOffsetContainer) {
                var c = e.fullScreenOffsetContainer.split(",");
                if (c) jQuery.each(c, function(e, i) {
                    u = jQuery(i).length > 0 ? u - jQuery(i).outerHeight(!0) : u
                }), e.fullScreenOffset.split("%").length > 1 && void 0 != e.fullScreenOffset && e.fullScreenOffset.length > 0 ? u -= jQuery(window).height() * parseInt(e.fullScreenOffset, 0) / 100 : void 0 != e.fullScreenOffset && e.fullScreenOffset.length > 0 && (u -= parseInt(e.fullScreenOffset, 0))
            }
            f = u
        } else void 0 != e.minHeight && f < e.minHeight && (f = e.minHeight);
        e.c.closest(".rev_slider_wrapper").css({
            height: f
        })
    } catch (d) {
        console.log("Failure at Presize of Slider:" + d)
    }
};

function createhomepageslider() {
   var htmlDiv = document.getElementById("rs-plugin-settings-inline-css"); var htmlDivCss="";
				if(htmlDiv) {
					htmlDiv.innerHTML = htmlDiv.innerHTML + htmlDivCss;
				}else{
					var htmlDiv = document.createElement("div");
					htmlDiv.innerHTML = "<style>" + htmlDivCss + "</style>";
					document.getElementsByTagName("head")[0].appendChild(htmlDiv.childNodes[0]);
				}
  var htmlDivCss = '	#rev_slider_138_1_wrapper .tp-loader.spinner4 div { background-color: #ffffff !important; } ';
					var htmlDiv = document.getElementById('rs-plugin-settings-inline-css');
					if(htmlDiv) {
						htmlDiv.innerHTML = htmlDiv.innerHTML + htmlDivCss;
					}
					else{
						var htmlDiv = document.createElement('div');
						htmlDiv.innerHTML = '<style>' + htmlDivCss + '</style>';
						document.getElementsByTagName('head')[0].appendChild(htmlDiv.childNodes[0]);
					}

    setREVStartSize({
        c: jQuery('#rev_slider_138_1'),
       responsiveLevels: [1600,1441,778,601], gridwidth: [1920,1440,778,480], gridheight: [690,500,400,440], sliderLayout: 'auto'});
    var revapi138,
        tpj = jQuery;
    if (tpj("#rev_slider_138_1").revolution == undefined) {
        revslider_showDoubleJqueryError("#rev_slider_138_1");
    } else{
		revapi138 = tpj("#rev_slider_138_1").show().revolution({
			sliderType:"standard",
			jsFileLocation:"",
			sliderLayout:"auto",
			dottedOverlay:"none",
			delay:9000,
			navigation: {
				onHoverStop:"off",
			},
			responsiveLevels:[1600,1441,778,601],
			visibilityLevels:[1600,1441,778,601],
			gridwidth:[1920,1440,778,480],
			gridheight:[690,500,400,440],
			lazyType:"none",
			scrolleffect: {
				fade:"on",
				on_slidebg:"on",
				disable_on_mobile:"off",
			},
			parallax: {
				type:"scroll",
				origo:"enterpoint",
				speed:400,
				speedbg:10,
				speedls:0,
				levels:[5,10,15,20,25,30,35,40,45,46,47,48,49,50,51,55],
			},
			shadow:0,
			spinner:"spinner4",
			stopLoop:"off",
			stopAfterLoops:-1,
			stopAtSlide:-1,
			shuffle:"off",
			autoHeight:"off",
			disableProgressBar:"on",
			hideThumbsOnMobile:"off",
			hideSliderAtLimit:0,
			hideCaptionAtLimit:0,
			hideAllCaptionAtLilmit:0,
			debugMode:false,
			fallbacks: {
				ignoreHeightChanges:"mobile",
				ignoreHeightChangesSize:0,
				simplifyAll:"off",
				nextSlideOnWindowFocus:"off",
				disableFocusListener:true,
			}
		});
	}
    setTimeout(function() {
        window.homeSlider = true;
        jQuery("#rev_slider_138_1 a[target]").removeAttr("target");
    }, 300);
}


//product slider hompage
function productslider() {
    var container = jQuery('#productslider');
    var pagination = container.find('.swiper-pagination');
    if (container.length) {
        var swiper = new Swiper((container), {
            effect: 'slide',
            speed: 400,
            autoHeight: true, //enable auto height
            zoom: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: true,
            },
            breakpoints: {
            // when window width is <= 320px
            600: {
                 speed: 900,
                 autoHeight: false, //enable auto height
             }
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }
        });
    }
}

//review slider hompage
function shoutoutsslider() {
    var container = jQuery('#shoutoutsslider');
    var pagination = container.find('.swiper-pagination');
    // shoutouts swiper
    var myswiper = new Swiper((container), {
        // Optional parameters
        direction: 'horizontal',
        autoHeight: false,
        loop: true,
        autoplay: {
            delay: 4000,
            disableOnInteraction: true,
        },
        slidesPerView: 5,
        updateOnImagesReady: true,
        centeredSlides: true,
        spaceBetween: 20,
        breakpoints: {
            // when window width is <= 320px
            600: {
                slidesPerView: 3,
                speed: 900,
            }
        },
        on: {
            slideChange: function() {
                container = jQuery(this)[0].el;
                var name = jQuery(this.slides[this.activeIndex]).find('a').attr('name');
                var review = jQuery(this.slides[this.activeIndex]).find('a').attr('review');
                jQuery(container).find('.details').fadeOut(300, function() {
                    jQuery(container).find('.details').html('<h3 class="text-center">' + name + '</h3><h2 class="text-center">' + review + '</h2>');
                }).fadeIn(300);
            }
        }
    })
}


function initmodals(event) {
    var ModalEffects = (function() {

        function init() {

            var overlay = jQuery('.md-overlay').get(0);
            var body = jQuery(document.body).get(0);
             
            [].slice.call(body.querySelectorAll('.md-trigger')).forEach(function(el, i) {
                 
                   var modal = body.querySelector('#' + el.getAttribute('data-modal'));
                    
                    [].slice.call(body.querySelectorAll('.md-close')).forEach(function(el, i) {
                      
                     el.addEventListener('click', function(ev) {
                    //ev.stopPropagation();
                    removeModalHandler();
                });
                    });
              
              if( jQuery(modal).find('.md-close2').length) {
                 close2 = modal.querySelector('.md-close2');
                 close2.addEventListener('click', function(ev) {
                  //  ev.stopPropagation();
                    removeModalHandler();
                });
              }

                function removeModal(hasPerspective) {
                    classie.remove(modal, 'md-show');
                    classie.remove(body, 'md-show');
                    jQuery(modal).find('.jquery-youtube-tubeplayer').tubeplayer("pause");
                    if (hasPerspective) {
                        classie.remove(event.currentTarget.documentElement, 'md-perspective');
                    }
                }

                function removeModalHandler() {
                    removeModal(classie.has(el, 'md-setperspective'));
                }

                jQuery(el).off('click').on('click', function(ev) {
                    classie.add(modal, 'md-show');
                    classie.add(body, 'md-show');
                    var video = jQuery(modal).find('.videobox');
                  if(video.length) {  
                    if(video.tubeplayer('data') != undefined) {
                      video.tubeplayer("play");                     
                    }else{
                    video.loadvideo();
                    video.one('playerLoaded', function() {
                      if(window.mobile == undefined) {
                       video.tubeplayer("play");                       
                      }
                    }); 
                    }

                  }
                    overlay.removeEventListener('click', removeModalHandler);
                    overlay.addEventListener('click', removeModalHandler);

                    if (classie.has(el, 'md-setperspective')) {
                        setTimeout(function() {
                            classie.add(event.currentTarget.documentElement, 'md-perspective');
                        }, 25);
                    }
                });

               

            });

        }

        init();

    })();
}

function runig() {
  
 
 
    // what we post swiper
 var userfeed = new Instafeed({
        get: 'user',
        userId: 255618386,
        limit: 30,
    target: jQuery(this).find('.instafeed').get(0),
    accessToken: '255618386.6a7999e.ac69f6919174435f853b241e5e933f06',
        resolution: 'low_resolution',               
            
        template: '<div class="swiper-slide"><img alt="{{caption}}" src="{{image}}" /></div>',
         
   mock: true,
   success: function(response) {

 console.log(response.data)
  var myStringArray = response.data;
  var arrayLength = myStringArray.length;
  for (var i = 0; i < arrayLength; i++) {
    //Do something
    $.mobile.activePage.find('.instafeed').append('<div class="swiper-slide"><div class="flex-video"><img  src="' + myStringArray[i].images.low_resolution.url + '" /></div></div>');

}
},
          after: function() { 
    
            var mySwiper = new Swiper ('.instagram-swiper', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    speed: 900,
    slidesPerView: 3,
    centeredSlides: true,
    spaceBetween: 10,
         autoplay: {
        delay: 2500,
        disableOnInteraction: true,
      },          
     breakpoints: {
    // when window width is <= 320px
    400: {
      slidesPerView: 3,
    }
    },
  }) 
         }
          
        });
    userfeed.run();
 
}


//convert a decimal into a fraction (Size Chart)
function fraction(decimal) {
    if (String(decimal).indexOf('.') <= -1) {
        return decimal;
    }
    if (!decimal) {
        decimal = this;
    }
    whole = String(decimal).split('.')[0];
    decimal = parseFloat("." + String(decimal).split('.')[1]);
    num = "1";
    for (z = 0; z < String(decimal).length - 2; z++) {
        num += "0";
    }
    decimal = decimal * num;
    num = parseInt(num);
    for (z = 2; z < decimal + 1; z++) {
        if (decimal % z == 0 && num % z == 0) {
            decimal = decimal / z;
            num = num / z;
            z = 2;
        }
    }
    //if format of fraction is xx/xxx
    if (decimal.toString().length == 2 && num.toString().length == 3) {
        //reduce by removing trailing 0's
        decimal = Math.round(Math.round(decimal) / 10);
        num = Math.round(Math.round(num) / 10);
    }
    //if format of fraction is xx/xx
    else if (decimal.toString().length == 2 && num.toString().length == 2) {
        decimal = Math.round(decimal / 10);
        num = Math.round(num / 10);
    }
    //get highest common factor to simplify
    var t = HCF(decimal, num);
    //return the fraction after simplifying it
    return ((whole == 0) ? "" : whole + " ") + decimal / t + "/" + num / t;
}

function HCF(u, v) {
    var U = u,
        V = v
    while (true) {
        if (!(U %= V)) return V
        if (!(V %= U)) return U
    }
}